
import { useEffect, useRef, useState } from 'react';

export default function Collection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="bg-white py-20"
    >
      <div className="w-full">
        <div 
          className={`transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="text-center mb-12 px-6 md:px-12">
            <div className="inline-block relative">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 tracking-[0.2em] mb-4">
                MILAN  LIFE
              </h2>
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-black"></div>
            </div>
          </div>
          
          <div className="w-full">
            <img 
              src="https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/49028ba8014b23c5c02dbab787949f8f.png"
              alt="MILAN Collection"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
